import { s } from 'lib/safe';

export const isLTDF = (sub: any) => s(s(sub.plan).id).startsWith('lifetimedeal_ltdf');
